import {
    CREATE_PRICE_MAPPING_REQUEST,
    CREATE_PRICE_MAPPING_SUCCESS,
    CREATE_PRICE_MAPPING_FAILURE,
    DELETE_PRICE_MAPPING_REQUEST,
    DELETE_PRICE_MAPPING_SUCCESS,
    DELETE_PRICE_MAPPING_FAILURE,
    FETCH_SINGLE_PRICE_MAPPING_REQUEST,
    FETCH_SINGLE_PRICE_MAPPING_SUCCESS,
    FETCH_SINGLE_PRICE_MAPPING_FAILURE,
    FETCH_PRICE_MAPPING_REQUEST,
    FETCH_PRICE_MAPPING_SUCCESS,
    FETCH_PRICE_MAPPING_FAILURE,
    UPDATE_PRICE_MAPPING_REQUEST,
    UPDATE_PRICE_MAPPING_SUCCESS,
    UPDATE_PRICE_MAPPING_FAILURE,
    RESET_PRICE_MAPPING_INFO,
    CREATE_PRICE_MAPPING_FORM,
    UPDATE_PRICE_MAPPING_FORM,
    FETCH_CURRENCY_SUCCESS
} from './priceMapping.actionsType';

export const PRICE_MAPPING = 'priceMapping';

let today = new Date();

let initialState = {
    loading: false,
    priceMappingList: [],
    currency: [],
    priceMappingform: {
        fldEntryDt: today.toISOString().split('T')[0]
    },
    selectedState: {},
    errorMessage: ''
};

export let priceMappingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRICE_MAPPING_REQUEST:
        case CREATE_PRICE_MAPPING_REQUEST:
        case UPDATE_PRICE_MAPPING_REQUEST:
        case FETCH_SINGLE_PRICE_MAPPING_REQUEST:
        case DELETE_PRICE_MAPPING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRICE_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                priceMappingList: updatePayload
            };
        case FETCH_CURRENCY_SUCCESS:
            return {
                ...state,
                currency: updatePayload
            };
        case CREATE_PRICE_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                priceMappingform: {
                    fldEntryDt: today.toISOString().split('T')[0]
                }
            };
        case UPDATE_PRICE_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                priceMappingform: {
                    fldEntryDt: today.toISOString().split('T')[0]
                }
            };
        case FETCH_SINGLE_PRICE_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                priceMappingform: {
                    ...updatePayload,
                    fldEntryDt: updatePayload.fldEntryDt.split('T')[0],
                    fldValidfrom: updatePayload.fldValidfrom.split('T')[0],
                    fldVaildTo: updatePayload.fldVaildTo.split('T')[0]
                }
            };
        case DELETE_PRICE_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_PRICE_MAPPING_INFO:
            return {
                ...state,
                priceMappingform: {
                    fldEntryDt: today.toISOString().split('T')[0]
                }
            };
        case CREATE_PRICE_MAPPING_FORM:
        case UPDATE_PRICE_MAPPING_FORM:
            return {
                ...state,
                loading: false,
                priceMappingform: {
                    ...state.priceMappingform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PRICE_MAPPING_FAILURE:
        case CREATE_PRICE_MAPPING_FAILURE:
        case UPDATE_PRICE_MAPPING_FAILURE:
        case FETCH_SINGLE_PRICE_MAPPING_FAILURE:
        case DELETE_PRICE_MAPPING_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
